// extracted by mini-css-extract-plugin
export default {"description":"db6897371c880c9d","loader":"_4b1ef17d2f0ddc24"};